import ToggleThemeSwitch from './ToggleThemeSwitch';
import { Box, Flex, Spacer, Heading, Text, useColorModeValue, Container, HStack, Image } from '@chakra-ui/react'

import logo from './datarunk-logo.svg';

function Header() {
    const bg = useColorModeValue('rgba(255, 255, 255, 0.9)', 'rgba(10, 14, 26, 0.9)');
    const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');

    return (
        <Box
            as="header"
            position="sticky"
            top="0"
            zIndex="sticky"
            bg={bg}
            backdropFilter="blur(12px)"
            borderBottom="1px"
            borderColor={borderColor}
            mb={8}
            boxShadow="sm"
            transition="all 0.3s"
        >
            <Container maxW="container.xl">
                <Flex align="center" py={3} h="70px">
                    <HStack spacing={4} align="center">
                        <a href="https://www.datarunk.com" target="_blank" rel="noopener noreferrer">
                            <Image
                                src={logo}
                                alt="DataRunk Logo"
                                h="32px"
                                w="auto"
                                transition="transform 0.2s"
                                _hover={{ transform: 'scale(1.05)' }}
                                // If the logo is white by default, we might need to invert it for light mode if it's not visible
                                // Assuming the logo provided is white (based on 'Branco' in URL)
                                filter={useColorModeValue('invert(1) brightness(0.2)', 'none')}
                            />
                        </a>

                        <Box w="1px" h="24px" bg={useColorModeValue('gray.300', 'gray.600')} mx={2} display={{ base: 'none', md: 'block' }} />

                        <Flex direction="column" justify="center" lineHeight="1.1">
                            <Heading
                                size='md'
                                letterSpacing="-0.5px"
                                fontWeight="800"
                                bgGradient="linear(to-r, brand.500, brand.300)"
                                bgClip="text"
                            >
                                Splunk Sizing
                            </Heading>
                            <Text
                                fontSize='10px'
                                fontWeight="bold"
                                color={useColorModeValue('gray.500', 'gray.400')}
                                letterSpacing="2px"
                                textTransform="uppercase"
                            >
                                Calculator
                            </Text>
                        </Flex>
                    </HStack>

                    <Spacer />
                    <ToggleThemeSwitch />
                </Flex>
            </Container>
        </Box>
    );
}

export default Header;
